import React, { useState } from 'react';
import Layout from '../../../../components/Layout';
import { COLONNINE, GATEWAY, Colonnina } from './dati';
import VistaColonnine from './VistaColonnine';
import VistaSchedaColonnina from './VistaSchedaColonnina';
import VistaBadge from './VistaBadge';
import VistaSessioni from './VistaSessioni';
import VistaRiaddebiti from './VistaRiaddebiti';

/* ============================================================================
 * MOCKUP — Ricarica veicoli (Gestione Aziendale → Ricarica veicoli)
 *
 * Le schede in alto simulano le voci di menu del gruppo; dall'elenco colonnine
 * si apre la scheda di una colonnina. Dati finti in dati.ts, nessuna chiamata
 * API, nessuna modifica salvata.
 *
 * Spec:      docs/superpowers/specs/2026-10-25-ricarica-veicoli-ocpp-design.md
 * Contratto: docs/ricarica-veicoli-contratto-api.md
 * ============================================================================ */

type Vista = 'colonnine' | 'badge' | 'sessioni' | 'riaddebiti';

const VOCI: { id: Vista; label: string }[] = [
  { id: 'colonnine', label: 'Colonnine' },
  { id: 'badge', label: 'Badge' },
  { id: 'sessioni', label: 'Sessioni' },
  { id: 'riaddebiti', label: 'Riaddebiti' },
];

export default function MockupRicaricaVeicoli() {
  const [vista, setVista] = useState<Vista>('colonnine');
  const [colonninaId, setColonninaId] = useState<number | null>(null);
  // Condivisi fra elenco e scheda: le colonnine create e la simulazione del
  // gateway restano quando si apre una scheda e si torna all'elenco
  const [colonnine, setColonnine] = useState<Colonnina[]>(COLONNINE);
  const [gatewayOk, setGatewayOk] = useState(GATEWAY.raggiungibile);

  const cambiaVista = (v: Vista) => {
    setVista(v);
    setColonninaId(null);
  };

  return (
    <Layout>
      <div className="bop-alert bop-alert--warning">
        Mockup con dati finti: le schede simulano le voci del gruppo "Ricarica veicoli". Nessuna modifica viene salvata.
      </div>
      <div className="bop-tabs">
        {VOCI.map((v) => (
          <button key={v.id} className={`bop-tab${vista === v.id ? ' active' : ''}`} onClick={() => cambiaVista(v.id)}>
            {v.label}
          </button>
        ))}
      </div>
      {vista === 'colonnine' && colonninaId === null && (
        <VistaColonnine
          colonnine={colonnine}
          gatewayOk={gatewayOk}
          onCrea={(c) => setColonnine([...colonnine, c])}
          onGatewayOk={setGatewayOk}
          onApri={setColonninaId}
        />
      )}
      {vista === 'colonnine' && colonninaId !== null && (
        <VistaSchedaColonnina
          colonnina={colonnine.find((c) => c.id === colonninaId) ?? colonnine[0]}
          gatewayOk={gatewayOk}
          onAggiorna={(aggiornata) => setColonnine(colonnine.map((c) => (c.id === aggiornata.id ? aggiornata : c)))}
          onIndietro={() => setColonninaId(null)}
        />
      )}
      {vista === 'badge' && <VistaBadge />}
      {vista === 'sessioni' && <VistaSessioni />}
      {vista === 'riaddebiti' && <VistaRiaddebiti />}
    </Layout>
  );
}
